<script>
import TablePage from '../../../../../components/table_page';
import request from '../../../../../utils/request';
import Form from './form';

export default {
  name: 'table-component',
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {
      requestUrl: '/sfa/sfavisitstepcolletproduct/list',
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
    };
  },
  created() {
    this.getConfigList('competitor_product_management');
  },
  methods: {
    cellClick({ row, column }) {
      if (column.property === 'productName') {
        this.formConfig = {
          type: 'view',
          id: row.id,
        };
        this.openDrawer();
      }
    },
    modalClick({ val, row }) {
      this.formConfig = {};
      let urls = '';
      let text = '';
      if (val.code === 'add') {
        this.modalConfig.title = '新增';
        this.openDrawer();
      } else if (val.code === 'edit') {
        this.formConfig = {
          type: val.code,
          id: row.id,
        };
        this.modalConfig.title = '编辑';
        this.openDrawer();
      } else if (val.code === 'delete') {
        urls = '/sfa/sfavisitstepcolletproduct/delete';
        text = '删除';
        this.operationClick(urls, text);
      } else if (val.code === 'enable') {
        urls = '/sfa/sfavisitstepcolletproduct/enable';
        text = '启用';
        this.operationClick(urls, text);
      } else if (val.code === 'disable') {
        urls = '/sfa/sfavisitstepcolletproduct/disable';
        text = '禁用';
        this.operationClick(urls, text);
      }
    },
    operationClick(urls, text) {
      let datas = [];
      if (this.selection.length > 0) {
        datas = this.selection;
        request.post(urls, datas).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: `${text}成功`,
            });
            this.selection = [];
            this.getList();
          }
        });
      } else {
        this.$message({
          type: 'error',
          message: '请选择数据',
        });
      }
    },
  },
};
</script>
